import type { Item, GameState } from "../types";
import { CONSTANTS } from "../data";

// Pure functions for pricing, tips, XP, and level progression

export const calculatePrice = (item: Item, context?: any): number => {
  // Add modifiers for context if needed
  return item.price;
};

export const calculateTips = (item: Item, context?: any): number => {
  // Add modifiers for context if needed
  let tip = item.price || 0;
  if (context?.tipBonus) {
    tip = Math.round(tip * (1 + context.tipBonus));
  }
  return tip;
};

export const calculateXp = (item: Item, context?: any): number => {
  // Use XP_REWARDS from CONSTANTS
  if (CONSTANTS.SIMPLE_DRINKS.includes(item.id)) return CONSTANTS.XP_REWARDS.simple;
  if (CONSTANTS.PREMIUM_DRINKS.includes(item.id)) return CONSTANTS.XP_REWARDS.premium;
  return CONSTANTS.XP_REWARDS.medio;
};

export const getLevelFromXp = (xp: number): number => {
  let level = 1;
  for (const [lvl, threshold] of Object.entries(CONSTANTS.LEVEL_XP_THRESHOLDS)) {
    if (xp >= threshold) {
      level = parseInt(lvl, 10);
    } else {
      break; // Stop when we find the first threshold the player hasn't met
    }
  }
  return level;
};

export const checkUnlocks = (state: GameState) => {
  // Returns a list of unlocks for the current level
  const unlocks = CONSTANTS.LEVEL_UNLOCKS[state.level];
  return unlocks || {};
};

export const handlePrestige = (state: GameState) => {
  // Returns a new state with prestige applied
  return {
    ...state,
    level: 1,
    xp: 0,
    coins: CONSTANTS.STARTING_COINS,
    inventory: { ...CONSTANTS.STARTING_INVENTORY },
    prestigeLevel: state.prestigeLevel + 1,
    discoveredRecipes: [],
    // Keep settings, tutorialState, and legendaryUnlocks as needed
  };
};
